import React from 'react'
import { Helmet } from 'react-helmet'
import metaImage from '../assets/images/meta/Dev-portal-meta-image.png'
import {graphql, useStaticQuery} from 'gatsby';

export default function SEO({
                              title,
                              description,
                              url,
                              defaultTitle,
                              defaultDescription,
                              defaultUrl
                            }) {
  // Use the page-specific values if available, otherwise fall back to defaults
  const seoTitle = title || defaultTitle
  const seoDescription = description || defaultDescription
  const seoUrl = url || defaultUrl
  const data = useStaticQuery(graphql`{ site { siteMetadata { siteUrl }} }`)
  const { siteUrl } = data.site.siteMetadata
  const seoImage = `${siteUrl}${metaImage}`
  return (
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoUrl} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:image" content={seoImage} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={seoUrl} />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={seoImage} />
      </Helmet>
  )
}
